import { render } from "./TestExpired.vue?vue&type=template&id=30580abc&scoped=true"
import script from "./TestExpired.vue?vue&type=script&lang=js"
export * from "./TestExpired.vue?vue&type=script&lang=js"

import "./TestExpired.vue?vue&type=style&index=0&id=30580abc&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30580abc"]])

export default __exports__